/* SH Updated: July 2026 - PDP gallery cold-paint re-measure (lane 4b)

   DEFECT (confirmed on live theme 156129493219, real iPhone iOS 26.5.2, cold cache,
   Jul 27 2026): on a cold first paint the product gallery's Flickity instance measures
   every cell at zero width and caches it. Verified state at that moment:

       CELLS: 4   cellSel: [data-group="color_black"]   initIdx: 0   selIdx: 0
       x:  "0,0,0,0"
       cw: "0,0,0,0"

   The cell set, the cellSelector and the selected index are all CORRECT - only the
   cached geometry is wrong. Consequences, all of which follow from that one fact:
     - every cell sits at x=0, so the slides overlap in a single stack and the visible
       image is whichever paints last, not the one Flickity has selected;
     - slideableWidth is 0, so a swipe advances the index and translates 0px. The
       pagination dot moves, the photograph does not. Product photos past the first are
       unreachable.
   A reload or a gallery-tab round-trip repairs it because both run reloadCells+resize.

   This is PRE-EXISTING theme behaviour, not caused by the gallery-tabs build: the
   control product (no custom.product_view_images, no tabs, zero lines of that build
   executing) reproduces it identically on the published theme.

   REMEDY: this file keys off the defect CONDITION, not its cause. It re-measures only
   when cells are actually collapsed AND the container has real width to measure
   against. On a healthy load every entry point short-circuits and nothing is called -
   no resize, no select, no reflow. That makes it inert on the warm path, which is the
   overwhelming majority of loads.

   Deliberately NOT an unconditional resize() at init: that would fire on every load
   including healthy ones, and would mask rather than repair. */
(function () {
  'use strict';

  var SELECTOR = '[data-product-photos]';
  var GIVE_UP_AFTER_MS = 12000;

  function flickityFor(el) {
    if (!window.Flickity) return null;
    var target = el.classList.contains('flickity-enabled') ? el : el.querySelector('.flickity-enabled');
    if (!target) return null;
    return window.Flickity.data(target) || null;
  }

  /* True only when Flickity holds cells whose cached width is zero. */
  function isCollapsed(flkty) {
    if (!flkty || !flkty.cells || !flkty.cells.length) return false;
    for (var i = 0; i < flkty.cells.length; i++) {
      var size = flkty.cells[i].size;
      if (!size || !size.width) return true;
    }
    return false;
  }

  /* Returns true when there is nothing left to do for this element (healthy or
     repaired), false when we should keep watching. */
  function repair(el) {
    var flkty = flickityFor(el);
    if (!flkty) return false; // not initialised yet - keep watching
    if (!isCollapsed(flkty)) return true; // healthy: touch nothing
    if (!el.getBoundingClientRect().width) return false; // container still collapsed

    var index = flkty.selectedIndex || 0;
    flkty.resize();
    if (isCollapsed(flkty)) return false; // re-measure did not take; try again later

    // resize() can leave the transform on a stale offset - restore the selection
    // without animation so the correct slide is framed.
    flkty.select(index, false, true);
    return true;
  }

  function watch(el) {
    if (el.shGalleryRemeasureBound) return;
    el.shGalleryRemeasureBound = true;

    var start = Date.now();
    var scheduled = false;

    function run() {
      scheduled = false;
      repair(el);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(run);
    }

    // Width arriving (0 -> N) is the exact moment the cached geometry became stale.
    // Kept alive rather than disconnected: a variant change re-inits Flickity and can
    // re-collapse, and schedule() is a no-op on healthy instances.
    if (window.ResizeObserver) {
      new ResizeObserver(schedule).observe(el);
    }

    // Images finishing decode can also be what unblocks layout. 'load' does not
    // bubble, so listen in the capture phase.
    el.addEventListener('load', schedule, true);

    window.addEventListener('load', schedule);
    document.addEventListener('DOMContentLoaded', schedule);

    // Backstop for anything the observers miss (e.g. Flickity initialising late).
    (function poll() {
      if (Date.now() - start > GIVE_UP_AFTER_MS) return;
      if (repair(el)) return;
      setTimeout(poll, 250);
    })();
  }

  function init() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) watch(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
